import { Card, Grid, Typography } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';
import UsersCard from './UsersCard';

function ListaUsuariosAsignados({ hostUser }) {
  const { userList } = useSelector((state) => state.dagpacket);
  const userListFilt = userList.filter((user) => user.id !== hostUser.id);
  const hostedUsers = userListFilt.filter((user) => user?.hostUser === hostUser.id);
  return (
    <Card sx={{ padding: '15px', marginTop: '10px' }}>
      <Typography variant="subtitle1">Usuarios asignados</Typography>
      <Grid container spacing={1} xs={12}>
        {hostedUsers.map((user) => (
          <UsersCard key={user.id} add={false} dataUser={user} hostUser={hostUser} />
        ))}
      </Grid>
    </Card>
  );
}

export default ListaUsuariosAsignados;
